import { render, staticRenderFns } from "./threeDchats.vue?vue&type=template&id=6e3c3a0e"
import script from "./threeDchats.vue?vue&type=script&lang=js"
export * from "./threeDchats.vue?vue&type=script&lang=js"
import style0 from "./threeDchats.vue?vue&type=style&index=0&id=6e3c3a0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports